// PrivateRoute.tsx
import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface Props {
  isAuthenticated: boolean;
  children?: ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ isAuthenticated, children }) => {
  let location = useLocation();
  if (!isAuthenticated) {
    localStorage.setItem(
      "redirectAfterLogin",
      `${location.pathname}${location.search}`
    );
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/registration" />;
};

export default PrivateRoute;
